import styled from "styled-components";
export const FacilitiesStyled = styled.div``;
